"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getBufferedDurationForStream_1 = require("./getBufferedDurationForStream");
function generateMetrics(videoElement, player, bandwidthEstimate) {
    var playbackPosition = videoElement.currentTime;
    var bufferedInfo = player.getBufferedInfo();
    var audio = getBufferedDurationForStream_1.default(playbackPosition, bufferedInfo.audio);
    var video = getBufferedDurationForStream_1.default(playbackPosition, bufferedInfo.video);
    var bufferedDuration = {
        audio: audio,
        video: video,
        min: Math.min(audio, video),
        max: Math.max(audio, video)
    };
    var metrics = {
        playbackPosition: playbackPosition,
        bufferedDuration: bufferedDuration,
        bandwidthEstimate: bandwidthEstimate
    };
    return metrics;
}
exports.default = generateMetrics;
//# sourceMappingURL=generateMetrics.js.map